function storeObject(storageName, object) {
    let newObject = Object.assign({}, object);
    localStorage.setItem(storageName, JSON.stringify(newObject));
}

function getObject(storageName) {
    return JSON.parse(localStorage.getItem(storageName));
}

export { storeObject, getObject };


// WEBPACK FOOTER //
// ./src/utils/Storage/StorageUtils.js